import * as _4 from 'lodash';
import { NCRSlot } from '../../../global/builders/ap_generic_slot_builder';
import { INVALID_ID } from '../../../global/constants/ap_id_constants';
import { APComponentStateModel } from '../../../global/models/ap_component_state_model';

export class NcrTile {
  id: NCRSlot['programSlot']['id'];
  slot: NCRSlot;
  programSlotId: NCRSlot['programSlot']['id'];
  expanded: boolean = false;
  disableSlot: boolean = false;
  theme: string;
  isEditable: boolean | string;
  showIcon: boolean = false;
  UIDAppend: string = _4.uniqueId();

  getIconPosition() {
    return this.expanded ? '90' : '0';
  }

  $onChanges() {
    this.id = this.slot.programSlot.id;
    const noTermAssigned = this.slot.termId === INVALID_ID;
    this.showIcon = !noTermAssigned;
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
    this.programSlotId = this.slot.programSlot.id;
    this.theme = this.slot.disableSlot ? 'gray' : 'primary';
  }

  toggleExpand() {
    if (this.slot.disableSlot) {
      return;
    }
    this.expanded = !this.expanded;
  }
}

angular.module('capability-ng-academic-planner').component('ncrTile', {
  templateUrl: 'capability-ng-academic-planner/src/global/components/ncr_tile/ncr_tile.html',
  bindings: {
    slot: '<',
    term: '<',
    isEditable: '<?'
  },
  transclude: true,
  controller: NcrTile
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/ncr_tile/ncr_tile.ts